// @ts-check
import React, { FC } from 'react'; // eslint-disable-line no-unused-vars
import PropTypes from 'prop-types';
import {
  ResponsiveContainer,
  LineChart as RCLineChart,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  Line,
} from 'recharts';
import { Stat } from '../types'; // eslint-disable-line no-unused-vars

/** @typedef {{
  data: Stat[],
  label: string
}} LineChartPropsType */

/** @type { React.ValidationMap<LineChartPropsType> } */
const propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      numReferrals: PropTypes.number.isRequired,
    })
  ).isRequired,
  label: PropTypes.string.isRequired,
};

/** @type { FC<LineChartPropsType> } */
const LineChart = ({ data, label }) => (
  <ResponsiveContainer width="100%" aspect={4.0 / 3.0}>
    <RCLineChart data={data}>
      <XAxis dataKey="label" />
      <YAxis />
      <CartesianGrid strokeDasharray="3 3" />
      <Tooltip />
      <Legend />
      <Line
        type="monotone"
        name={label}
        dataKey="numReferrals"
        stroke="#8884d8"
        activeDot={{ r: 8 }}
      />
    </RCLineChart>
  </ResponsiveContainer>
);

LineChart.propTypes = propTypes;
LineChart.displayName = 'LineChart';

export default LineChart;
